export default __webpack_public_path__ + "static/media/zen.cd504dc5.png";